<template>
  <div>
    <Sidebar></Sidebar>
    <Header></Header>
    <b-container fluid>
      <b-row>
        <b-col>
          <div class="mt-4">
            <a href="#/post">< Voltar</a>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <h3 class="my-4" v-show="newObj === 'novo'">
            Novo {{ this.entity.por }}
          </h3>
          <h3 class="my-4" v-show="newObj !== 'novo'">
            {{ this.entity.por }} edição:
          </h3>
        </b-col>
      </b-row>
      <b-row>
        <div v-show="loading" class="loading-holder">
          <div class="loading-spinner"></div>
        </div>
      </b-row>
      <b-row v-show="!loading">
        <b-col md="3" xs="12" class="mt-3"> </b-col>
        <b-col md="3" xs="12" class="mt-3">
          <!-- Field item -->
          <div role="group">
            <b-form-checkbox
              id="destaque"
              v-model="post.spotlight"
              name="destaque"
            >
              Destaque
            </b-form-checkbox>
          </div>
          <!-- Field item end -->
        </b-col>
        <b-col md="3" xs="12" class="mt-3">
          <!-- Field item -->
          <div role="group">
            <b-form-checkbox id="urgente" v-model="post.urgency" name="urgente">
              Urgente
            </b-form-checkbox>
          </div>
          <!-- Field item end -->
        </b-col>
        <b-col md="9" xs="12" class="mt-3">
          <!-- Field item -->
          <div role="group">
            <label for="nome">Title *</label>
            <b-form-input
              id="title"
              v-model="post.title"
              aria-describedby="input-live-help input-live-feedback"
              placeholder
              trim
            ></b-form-input>
          </div>
          <!-- Field item end -->
        </b-col>
        <b-col md="3" xs="12" class="mt-3">
          <!-- Field item -->
          <div role="group">
            <label for="nome">Data de Publicação: *</label>
            <b-form-input
              id="title"
              v-model="post.timestamp"
              aria-describedby="input-live-help input-live-feedback"
              placeholder
              required="required"
              type="date"
            ></b-form-input>
            <span></span>
          </div>
          <!-- Field item end -->
        </b-col>
        <b-col md="12" xs="12" class="mt-3">
          <div role="group">
            <label for="description">Descrição: *</label>
            <vue-editor
              id="description"
              useCustomImageHandler
              @imageAdded="handleImageAdded"
              v-model="post.description"
            ></vue-editor>
          </div>
        </b-col>
        <b-col md="12" xs="12" class="mt-3">
          <div role="group">
            <label for="description">Imagem: *</label>
            <div v-show="post.image">
              <b-img :src="post.image" fluid></b-img>
              <b-button type="submit" variant="primary" @click="removerImagem"
                >Remover Imagem</b-button
              >
            </div>
            <b-form-file
              v-model="file"
              @input="checkImage"
              placeholder="Selecione uma imagem ou arraste ela até aqui..."
              drop-placeholder="Solte o arquivo aqui..."
              accept=".jpg, .png, .gif"
              v-show="!post.image"
            ></b-form-file>
            <div v-show="imageSizeWarning != ''" class="mt-3 warningMessage">
              <font-awesome-icon :icon="['fas', 'exclamation-circle']" />
              <span>
                {{ imageSizeWarning }}
              </span>
            </div>
          </div>
        </b-col>
        <b-col md="12" class="mt-3">
          <b-form-group label="Categorias: *">
            <b-form-checkbox
              v-for="option in categoryOptions"
              v-model="post.category"
              :key="option.id"
              :value="option"
              name="categories"
              inline
            >
              {{ option.title }}
            </b-form-checkbox>
          </b-form-group>
        </b-col>
        <b-col md="12" class="mt-3">
          <label for="tags">Tags: *</label>
          <tags-input
            element-id="tags"
            v-model="post.tag"
            :existing-tags="tagOptions"
            :typeahead="true"
          ></tags-input>
        </b-col>

        <b-col md="8" class="mt-3">
          <b-form-group label="Meses em que a matéria estará em destaque:">
            <b-form-checkbox-group
              id="group-checkbox-month"
              v-model="post.months"
              :options="monthOptions"
              name="group-checkbox-month"
              class="rs-group-checkbox"
              inline
            ></b-form-checkbox-group>
          </b-form-group>
        </b-col>

        <b-col cols="12" class="mt-3">
          <label>Anexos:</label>
          <input
            type="file"
            @change="attachFiles"
            name="attachments"
            accept="image/gif,image/jpeg,image/png,image/bmp,image/jpg,application/pdf"
          />
        </b-col>
        <b-col cols="12" class="mt-1">
          <div class="attachments-holder">
            <div
              class="item"
              v-for="(item, index) in post.attachment"
              :key="index"
            >
              <a :href="item.file" target="_blank">{{ item.file.substring(item.file.lastIndexOf( "/" ) + 1 ) }}</a>
              <div @click="removeAttachment(item.id, index)" class="remove">
                Remover
              </div>
            </div>
          </div>
        </b-col>
        <b-col
          v-show="warningMessage != ''"
          cols="12"
          class="mt-3 warningMessage"
        >
          <font-awesome-icon :icon="['fas', 'exclamation-circle']" />
          <span>{{ warningMessage }}</span>
        </b-col>
        <b-col cols="12" class="mb-4">
          <div class="mt-4" v-show="!saving">
            <b-button type="submit" variant="primary" @click="save">
              <span>Salvar</span>
            </b-button>
            <b-button
              v-show="this.post.approvalStatus !== 'Aprovado' && isAdmin"
              type="submit"
              variant="success"
              @click="approve()"
            >
              <span>Aprovar</span>
            </b-button>
            <b-button
              v-show="this.post.approvalStatus !== 'Reprovado' && isAdmin"
              type="submit"
              variant="danger"
              v-b-modal.modal-center
            >
              <span>Reprovar</span>
            </b-button>
            <b-modal
              id="modal-center"
              hide-footer
              centered
              title="Por favor, informe o motivo da reprova"
            >
              <b-form-textarea
                v-model="post.observation"
                placeholder="digite o motivo..."
                rows="3"
              ></b-form-textarea>
              <b-row>
                <b-col cols="6">
                  <b-button
                    class="mt-3"
                    cols="6"
                    block
                    @click="$bvModal.hide('modal-center')"
                    >Cancelar</b-button
                  >
                </b-col>
                <b-col cols="6">
                  <b-button
                    class="mt-3"
                    variant="danger"
                    block
                    @click="reprove()"
                    :disabled="disableReproveButton"
                    >Reprovar</b-button
                  >
                </b-col>
              </b-row>
            </b-modal>
          </div>
          <div v-show="saving" class="loading-spinner mt-4"></div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import http from "@/http";
import router from "@/router";
import Sidebar from "../components/Sidebar";
import Header from "../components/Header";
import Footer from "../components/Footer";
import authentication from "../util/authentication";
import VueUploadMultipleImage from "vue-upload-multiple-image";
import { VueEditor } from "vue2-editor";

export default {
  name: "PostCrud",
  data() {
    return {
      entity: {
        eng: "post",
        por: "Post"
      },
      post: {
        title: "",
        description: "",
        image: "",
        spotlight: false,
        views: 0,
        claps: 0,
        category: [],
        tag: [],
        attachment: [],
        timestamp: new Date().toISOString().substr(0, 10),
        months: [],
        approvalStatus: "Pendente",
        observation: "",
        urgency: false
      },
      loading: true,
      saving: false,
      file: {},
      categoryOptions: [],
      tagOptions: [],
      monthOptions: [
        { text: "Janeiro", value: "01" },
        { text: "Fevereiro", value: "02" },
        { text: "Março", value: "03" },
        { text: "Abril", value: "04" },
        { text: "Maio", value: "05" },
        { text: "Junho", value: "06" },
        { text: "Julho", value: "07" },
        { text: "Agosto", value: "08" },
        { text: "Setembro", value: "09" },
        { text: "Outubro", value: "10" },
        { text: "Novembro", value: "11" },
        { text: "Dezembro", value: "12" }
      ],
      isAdmin: false,
      warningMessage: "",
      imageSizeWarning: ""
    };
  },
  components: {
    Sidebar,
    Header,
    Footer,
    VueEditor,
    VueUploadMultipleImage
  },
  methods: {
    checkImage() {
      console.log(this.file.size);
      if (!this.post.image && this.file.size > 716800) {
        this.imageSizeWarning =
          "Por favor, insira uma imagem com no máximo 750kb.";
      } else {
        this.imageSizeWarning = "";
      }
    },
    reprove() {
      this.post.approvalStatus = "Reprovado";
      this.save();
    },
    approve() {
      if (confirm(`Tem certeza que deseja APROVAR a publicação?`)) {
        this.post.approvalStatus = "Aprovado";
        this.save();
      }
    },
    uploadImage() {
      var formData = new FormData();
      formData.append("file", this.file);

      http
        .post("File", formData, authentication.getHeaders())
        .then(response => {
          this.post.image = response.data;
          this.cadastrarPost();
        })
        .catch(err => {
          console.error(err);
          this.saving = false;
        });
    },
    save() {
      if (!this.post.title) {
        this.warningMessage = "Por favor, preencha o campo título.";
        return;
      }

      if (!this.post.timestamp) {
        this.warningMessage = "Por favor, insira uma data de publicação.";
        return;
      }

      if (!this.post.description) {
        this.warningMessage = "Por favor, preencha o campo descrição.";
        return;
      }

      if (!this.post.image && !this.file.name) {
        this.warningMessage = "Por favor, insira uma imagem para o post.";
        return;
      }

      if (this.post.category.length < 1) {
        this.warningMessage = "Por favor, insira uma categoria.";
        return;
      }

      if (!this.post.image && this.file.size > 716800) {
        this.warningMessage =
          "Por favor, insira uma imagem com no máximo 750kb.";
        return;
      }

      this.saving = true;
      this.warningMessage = "";

      this.file.size ? this.uploadImage() : this.cadastrarPost();
    },
    cadastrarPost() {
      if (this.newObj === "novo") {
        http
          .post(this.entity.eng, this.post, authentication.getHeaders())
          .then(response => {
            alert("Cadastro realizado com sucesso.");
            router.push(`/${this.entity.por}`);
          })
          .catch(err => {
            console.error(err);
          })
          .finally(() => {
            this.saving = false;
          });
      } else {
        http
          .put(this.entity.eng, this.post, authentication.getHeaders())
          .then(response => {
            this.salvarAnexos(response.data.id);
            alert("Alterações salvas com sucesso.");
            router.push(`/${this.entity.por}`);
          })
          .catch(err => {
            console.error(err);
          })
          .finally(() => {
            this.saving = false;
          });
      }
    },
    salvarAnexos(postId) {
      this.post.attachment.map(attach => {
        console.log(this.post.attachment);
        if (!attach.id) {
          attach.postId = postId;
          attach.title = "";
          attach.description = "";

          http.post("Attachment", attach, authentication.getHeaders());
        }
      });
    },
    removerImagem() {
      this.post.image = null;
    },
    handleImageAdded: function(file, Editor, cursorLocation, resetUploader) {
      var formData = new FormData();
      formData.append("file", file);

      http
        .post("File", formData, authentication.getHeaders())
        .then(response => {
          let url = response.data;
          Editor.insertEmbed(cursorLocation, "image", url);
          resetUploader();
        });
    },
    attachFiles(event) {
      console.log(event.target.files);
      if (!event.target.files) return;
      let formData = new FormData();

      for (var i = 0; i < event.target.files.length; i++) {
        let file = event.target.files[0];
        formData.append("file", file);
      }

      http
        .post("File", formData, authentication.getHeaders())
        .then(response => {
          console.log(response)
          this.post.attachment.push({
            file: response.data
          });
        })
        .catch(err => {
          console.log(err);
        });
    },
    removeAttachment(id, index) {
      this.post.attachment.splice(index, 1);
      if (id) {
        http.delete("Attachment/" + id, authentication.getHeaders());
      }
    }
  },
  computed: {
    disableReproveButton() {
      if (this.post.observation) {
        return this.post.observation.length < 4;
      } else {
        return true;
      }
    },
    newObj() {
      return this.$route.params.id;
    }
  },
  created() {
    this.isAdmin = authentication.isAdmin();

    http.get("Category?take=-1").then(response => {
      this.categoryOptions = response.data.list;
    });

    http.get("Tag?take=-1").then(response => {
      this.tagOptions = response.data.list;
    });

    if (this.newObj !== "novo") {
      http
        .get(`${this.entity.eng}/${this.newObj}`, authentication.getHeaders())
        .then(response => {
          if (response.data) {
            this.post = response.data;
            this.post.attachment.map(attach => {
              attach.path = attach.file;
            });
            this.post.timestamp = new Date(this.post.timestamp)
              .toISOString()
              .substr(0, 10);
          } else {
            router.push(`/${this.entity.por}`);
          }
        })
        .catch(err => {
          console.error(err);
        })
        .finally(() => {
          this.loading = false;
        });
    } else {
      this.loading = false;
    }
  }
};
</script>

<style scoped>
input[type="date"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  display: none;
}

img {
  max-height: 220px;
}
</style>
<style>
.warningMessage {
  color: rgb(255, 0, 0);
  font-weight: 600;
}

.rs-group-checkbox > div {
  position: relative;
  width: 120px !important;
  height: 30px;
}

legend,
label:not(.custom-control-label) {
  font-weight: bold;
  font-size: 1em;
}

.attachments-holder {
  position: relative;
  width: 100%;
  display: flex;
  justify-content: flex-start;
  margin: 0px -15px 35px 0;
}

.attachments-holder .item {
  position: relative;
  padding: 6px 20px;
  background-color: #eee;
  display: grid;
  place-items: center;
  margin: 15px 15px 0 0;
  border-radius: 4px;
}

.attachments-holder .item p {
  margin: 0;
}

.attachments-holder .item .remove {
  position: absolute;
  bottom: -20px;
  font-size: 14px;
  color: rgb(197, 40, 40);
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/PostCrud.vue